import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import GateDetails from './section-components/gate-details';
import Footer from './global-components/footer-v2';
import {Helmet} from "react-helmet";

const GATE = () => {
    return <div>
        <Navbar />
        <Helmet>
            <title>Coaching For GATE Exam | Entance Exams for Master Degrees Chennai</title>
            <meta name="description" content="MIET offers coaching for GATE exam in Chennai. We help you to get admission in the best colleges for Master's programmes." />
        </Helmet>
        <PageHeader headertitle="GATE"/>
        <GateDetails />
        <Footer />
    </div>
}

export default GATE